// react
import { useCallback, useRef, useState } from 'react'

// external libs
import { Box, IconButton, makeStyles } from '@material-ui/core'
import { CheckOutlined, CloseOutlined } from '@material-ui/icons'
import { Form } from 'react-final-form'

// components
import Dialog from '../../../control/dialog/dialog'
import Textfield from '../../../control/textfield/textfield'

// hooks
import useTranslate from '../../../i18n/useTranslate'

// types
import type { DialogType } from '../../../control/dialog/dialog'
import type { ChecklistRequest } from '../../../services/um/useChecklist'

interface ChecklistItemFormProps {
    initialValues?: ChecklistRequest
    onSubmit?: (values: ChecklistRequest) => void
    onCancel?: () => void
}

function ChecklistItemForm(props: ChecklistItemFormProps) {
    const { initialValues, onSubmit, onCancel } = props
    const translate = useTranslate()
    const classes = useStyles()

    const dialogRef = useRef<Record<string, Function>>()
    const [dialogInfo, setDialogInfo] = useState<Partial<DialogType>>()

    const submitHandler = useCallback(
        (values) => {
            const isValid = !!values.nameTH?.trim() && !!values.nameEN?.trim()
            if (isValid) {
                setDialogInfo({
                    title: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.HEADER')}`,
                    content: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.CONFIRM')}`,
                    type: 'alert-confirm',
                    onClickConfirm: () => {
                        onSubmit?.(values)
                        dialogRef.current?.closeDialog()
                    },
                })
            } else {
                setDialogInfo({
                    title: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.HEADER')}`,
                    content: `${translate.get('MESSAGE.M023')}`,
                    type: 'alert-message',
                })
            }

            dialogRef.current?.openDialog()
        },
        [dialogRef],
    )

    return (
        <>
            <Form onSubmit={submitHandler} initialValues={initialValues}>
                {(props) => {
                    return (
                        <form className={classes.checklistItemForm} onSubmit={props.handleSubmit}>
                            <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} style={{ gap: 16 }}>
                                <Box flexGrow={1} flexShrink={1} mb={{ xs: 2, md: 0 }}>
                                    <Textfield
                                        name="nameTH"
                                        materialInputProps={{
                                            size: 'medium',
                                            placeholder: translate.get('LABEL.THAI'),
                                            label: translate.get('LABEL.THAI'),
                                        }}
                                    />
                                </Box>
                                <Box flexGrow={1} flexShrink={1} mb={{ xs: 2, md: 0 }}>
                                    <Textfield
                                        name="nameEN"
                                        materialInputProps={{
                                            size: 'medium',
                                            placeholder: translate.get('LABEL.ENG'),
                                            label: translate.get('LABEL.ENG'),
                                        }}
                                    />
                                </Box>

                                <Box display="flex" alignItems="flex-end" pb={3} flexShrink={0} style={{ gap: 16 }}>
                                    <IconButton type="submit" aria-label="submit" color="default">
                                        <CheckOutlined />
                                    </IconButton>
                                    <IconButton aria-label="cancel" color="secondary" onClick={onCancel}>
                                        <CloseOutlined />
                                    </IconButton>
                                </Box>
                            </Box>
                        </form>
                    )
                }}
            </Form>

            <Dialog onRef={(funcs) => (dialogRef.current = funcs)} {...dialogInfo} />
        </>
    )
}

const useStyles = makeStyles(() => ({
    checklistItemForm: {
        padding: 5,
    },
}))

export default ChecklistItemForm
